import Icon from 'veui/components/Icon'
import { IconPlusSquare } from 'dls-icons-vue'

Icon.register('plus-square', IconPlusSquare)
